"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCallbackPayloadState = void 0;
const types_utils_1 = require("../../types.utils");
exports.BaseCallbackPayloadState = {
    userId: types_utils_1.stringSchema,
    companyId: types_utils_1.stringSchema,
    existingQueryParams: types_utils_1.stringSchema.optional(),
    successRedirectUrl: types_utils_1.stringSchema,
    errorRedirectUrl: types_utils_1.stringSchema,
};
